import { useState } from "react";

import { useTokenListQuery } from "shared/api/use-token-list-query";

import { TradeContext } from "../context";
import { TradeThemeVariant, WithdrawFormType } from "../types";
import { DepositForm } from "./deposit-form/deposit-form";
import { Header, type Tab } from "./header";
import { TradeSkeleton } from "./skeleton";
import { WithdrawForm } from "./withdraw-form/withdraw-form";

type Props = {
  className?: string;
  theme?: TradeThemeVariant;
  onWithdrawSubmit: (data: WithdrawFormType, slippage: string) => Promise<void>;
};

export const Trade = ({ theme = "spearmint", onWithdrawSubmit }: Props) => {
  const [tab, setTab] = useState<Tab>("deposit");
  const tokenListQuery = useTokenListQuery();
  const [slippage, setSlippage] = useState("1");

  const depositTokens = tokenListQuery.data?.depositTokens ?? [];
  const withdrawTokens = tokenListQuery.data?.withdrawalTokens ?? [];

  return (
    <TradeContext value={{ theme, slippage }}>
      <Header
        slippage={slippage}
        onSlippageChange={setSlippage}
        tab={tab}
        onTabChange={setTab}
      />

      {tokenListQuery.isPending && <TradeSkeleton />}

      {tab === "deposit" && tokenListQuery.isSuccess && (
        <DepositForm currencies={depositTokens} />
      )}
      {tab === "withdraw" && (
        <WithdrawForm
          currencies={withdrawTokens}
          onWithdrawSubmit={onWithdrawSubmit}
        />
      )}
    </TradeContext>
  );
};
